/* eslint-disable */
import React, { Component } from "react";
import { B4FText } from "../B4FFields/B4FText";
import { B4FRadio } from "../B4FFields/B4FRadio";
import { B4FNumber } from "../B4FFields/B4FNumber";
import { B4FSelect } from "../B4FFields/B4FSelect";
import { B4FRadioMultiSelect } from "../B4FFields/B4FRadioMultiSelect";
import { useTranslation, withTranslation, Trans } from "react-i18next";
import { Checkbox, Circle, Heading, HStack } from "@chakra-ui/react";

function B4FInput(props: any) {
  const { t, i18n } = useTranslation();
  if (props.config) {
    return (
      <HStack>
        <Checkbox aria-label="visibility" />
        <Circle
          fontSize="11px"
          color="brand.bf4"
          borderRadius="20px"
          borderColor="brand.bf3"
          borderWidth="2px"
          width="20px"
          mb={4}
        >
          {props.index}
        </Circle>
        <Heading
          fontSize="16px"
          color="brand.bf3"
          fontWeight="normal"
          fontFamily="ABeeZee"
          mb={5}
        >
          <Trans>{t(props.data.label)}</Trans>
        </Heading>
      </HStack>
    );
  } else {
    switch (props.type) {
      case "TEXT":
        return (
          <B4FText
            label={props.label}
            placeholder={props.placeholder}
            id={props.id}
            value=""
            onChange={(e: any) => console.log(e)}
            visible={props.visible}
            isRequired={props.isRequired}
          />
        );
      case "NUMBER":
        return (
          <B4FNumber
            label={props.label}
            placeholder={props.placeholder}
            id={props.id}
            value=""
            onChange={(e: any) => console.log(e)}
            visible={props.visible}
          />
        );
      case "SELECT":
        return (
          <B4FSelect
            label={props.label}
            id={props.id}
            value=""
            onChange={(e: any) => console.log(e)}
            onBlur={(e: any) => console.log(e)}
            visible={props.visible}
            options={props.options}
          />
        );
      case "RADIO":
        return (
          <B4FRadio
            label={props.label}
            id={props.id}
            value=""
            onChange={(e: any) => console.log(e)}
            visible={props.visible}
            options={[
              { label: "YES_NO.YES", key: "YES", value: "yes" },
              { label: "YES_NO.NO", key: "NO", value: "no" },
            ]}
          />
        );
      case "SELECT_MULTIPLE":
        return (
          <B4FRadioMultiSelect
            label={props.label}
            id={props.id}
            value=""
            onChange={(e: any) => console.log(e)}
            visible={props.visible}
            options={props.options}
            maxVal={3}
            isRequired
          />
        );
      case "TITLE":
        return <h1>{t(props.label)}</h1>;
      default:
        return null;
    }
  }
}

export default withTranslation()(B4FInput);
